import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDeleteCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8M4.54 4.54c.33-.34.87-.34 1.2 0L8 6.79l2.25-2.25c.34-.34.88-.34 1.21 0 .34.33.34.87 0 1.2L9.21 8l2.25 2.25c.34.34.34.88 0 1.21-.33.34-.87.34-1.2 0L8 9.21l-2.25 2.25c-.34.34-.88.34-1.21 0-.34-.33-.34-.87 0-1.2L6.79 8 4.54 5.75c-.34-.34-.34-.88 0-1.21"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconDeleteCircle;
